import { memo } from 'react';
import { makeStyles } from '@mui/styles';
import { MasonTheme } from '@bymason-private/controller-v1-theme-augmentation';
import { IconButton } from '../../mui/IconButton';
import { FaChevronLeft, FaChevronRight } from '../Icons';

export interface CarouselSelectorProps {
  disableNext?: boolean;
  disablePrevious?: boolean;
  label: JSX.Element;
  onNextClick: () => void;
  onPreviousClick: () => void;
}

const useStyles = makeStyles((theme: MasonTheme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  leftButton: {
    marginRight: theme.spacing(1),
  },
}));

export default memo(function CarouselSelector({
  disableNext,
  disablePrevious,
  label,
  onNextClick,
  onPreviousClick,
}: CarouselSelectorProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {label}
      <IconButton className={classes.leftButton} disabled={disablePrevious} onClick={onPreviousClick}>
        <FaChevronLeft fontSize={12} />
      </IconButton>
      <IconButton disabled={disableNext} onClick={onNextClick}>
        <FaChevronRight fontSize={12} />
      </IconButton>
    </div>
  );
});
